import Validator from "../../helpers/validation";
import Inputmask from "../../../node_modules/inputmask/dist/inputmask.es6";

const CustomInput = {
    props: {
        title: {
            default: "",
            type: String,
        },

        type: {
            default: "text",
            type: String,
        },

        name: {
            default: "",
            type: String,
        },

        required: {
            default: false,
            type: Boolean,
        },

        placeholder: {
            default: "",
            type: String,
        },

        validation: {
            type: Array,
            default() {
                return [];
            },
        },

        mask: {
            default: "",
            type: String,
        },

        modelValue: {
            type: [String, Number],
        },

        disabled: {
            default: false,
            type: Boolean,
        },
    },

    data() {
        return {
            input_value: null,

            error_message: null,

            valid: false,

            should_validate: false,
        };
    },

    mounted() {
        this.setMask();

        this.setEventListeners();
        this.setDisabledClasses();

        if (this.modelValue) {
            this.input_value = this.modelValue;
            this.$refs["node"].classList.add("has-value");
            this.validate();
            this.setValidationClasses();
        }
    },

    watch: {
        modelValue(val) {
            if (val === this.input_value) {
                return;
            }

            this.input_value = val;

            this.validate();
            this.setValidationClasses();
        },

        validation() {
            this.validate();
            this.setValidationClasses();
        },

        disabled() {
            this.setDisabledClasses();
        },
    },

    methods: {
        handleInput() {
            if (this.validation && this.validation.length) {
                this.should_validate = true;
                this.validate();
                this.setValidationClasses();
            }

            this.$emit("update:modelValue", this.input_value, this.valid);
        },

        setValidationClasses() {
            if (this.loading) {
                return;
            }

            const el = this.$refs["node"];

            if (el) {
                if (this.error_message) {
                    el.classList.remove("valid");
                    el.classList.add("invalid");
                    return;
                }

                if (this.valid) {
                    el.classList.remove("invalid");
                    el.classList.add("valid");
                    return;
                }

                el.classList.remove("invalid");
                el.classList.remove("valid");
            }
        },

        setDisabledClasses() {
            if (this.loading) {
                return;
            }

            const el = this.$refs["node"];

            if (!el) {
                return;
            }

            if (this.disabled) {
                el.classList.add("disabled");
                return;
            }

            el.classList.remove("disabled");
        },

        setMask() {
            if (this.mask) {
                Inputmask(this.mask).mask(this.$refs["input"]);
            }
        },

        setEventListeners() {
            const el = this.$refs["node"];

            const input = el.querySelector(
                "input[type=text], input[type=number], input[type=password], input[type=email]"
            );

            input.addEventListener("focus", () => {
                el.classList.add("focus");
            });

            input.addEventListener("blur", () => {
                if (input.value) {
                    el.classList.add("has-value");
                } else {
                    el.classList.remove("has-value");
                }

                el.classList.remove("focus");
            });
        },

        validate() {
            if(!this.should_validate) {
                return
            }

            const message = Validator.validate({
                validationArray: this.validation,
                value: this.input_value,
                name: this.name,
                mask: this.mask,
            });
            if (message) {
                this.error_message = message;
                this.$emit("error", this.error_message);
                this.valid = false;
                return;
            }

            this.error_message = null;
            this.valid = true;
            this.$emit("valid");
        },

        hasValidationErrors() {
            this.should_validate = true;
            this.validate();
            this.setValidationClasses();

            if (this.valid) {
                return false;
            }

            return true;
        },

        trimSpaces() {
            if (this.input_value) {
                this.input_value = this.input_value.trim();
            }
        },
    },

    template: /*html*/ `
    <div class="field" ref="node">
        <label>{{title}}<span v-if="required">*</span></label>
        <input :type="type" autocomplete="off" v-model="input_value" @input="handleInput" :placeholder="placeholder" ref="input" @change="trimSpaces" :disabled="disabled">
        <div class="input-errors" v-html="error_message"></div>
    </div>
  `,
};

export default CustomInput;
